import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import './App.css';
import NavBar from './components/NavBar';
import Dashboard from './pages/Dashboard';
import Workspaces from './pages/Workspaces';
import Users from './pages/Users';
import SystemHealth from './pages/SystemHealth';
import CameraSettings from './pages/CameraSettings';
import LoginPage from './pages/LoginPage';
import { AuthProvider } from './auth/AuthContext';
import RequireSuperadmin from './auth/RequireSuperadmin';
// Removed: AnalyticsRecordings, AnalyticsRecordingsPerCoach (hidden)
import AnalyticsActiveRecordings from './pages/AnalyticsActiveRecordings';
import AnalyticsNewUsersByMonth from './pages/AnalyticsNewUsersByMonth';
import AnalyticsCostAttribution from './pages/AnalyticsCostAttribution';
import AnalyticsComments from './pages/AnalyticsComments';
import UserDetail from './pages/UserDetail';
import UserVideos from './pages/UserVideos';
import UserComments from './pages/UserComments';

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <div className="min-h-screen bg-gray-50 text-gray-900 font-sans overflow-x-hidden">
          <NavBar />
          <div className="p-6 pt-20">
            <Routes>
              <Route path="/" element={<Navigate to="/dashboard" replace />} />
              <Route path="/login" element={<LoginPage />} />
              <Route path="/dashboard" element={<RequireSuperadmin><Dashboard /></RequireSuperadmin>} />
              <Route path="/workspaces" element={<RequireSuperadmin><Workspaces /></RequireSuperadmin>} />
              <Route path="/users" element={<RequireSuperadmin><Users /></RequireSuperadmin>} />
              <Route path="/users/:id" element={<RequireSuperadmin><UserDetail /></RequireSuperadmin>} />
              <Route path="/users/:id/videos" element={<RequireSuperadmin><UserVideos /></RequireSuperadmin>} />
              <Route path="/users/:id/comments" element={<RequireSuperadmin><UserComments /></RequireSuperadmin>} />
              <Route path="/cameras/live" element={<RequireSuperadmin><SystemHealth /></RequireSuperadmin>} />
              <Route path="/cameras/settings" element={<RequireSuperadmin><CameraSettings /></RequireSuperadmin>} />
              {/* Hidden pages: /analytics/recordings and /analytics/recordings-per-coach */}
              <Route path="/analytics/active" element={<RequireSuperadmin><AnalyticsActiveRecordings /></RequireSuperadmin>} />
              <Route path="/analytics/new-users" element={<RequireSuperadmin><AnalyticsNewUsersByMonth /></RequireSuperadmin>} />
              <Route path="/analytics/costs" element={<RequireSuperadmin><AnalyticsCostAttribution /></RequireSuperadmin>} />
              <Route path="/analytics/comments" element={<RequireSuperadmin><AnalyticsComments /></RequireSuperadmin>} />
            </Routes>
          </div>
        </div>
      </BrowserRouter>
    </AuthProvider>
  );
}
